import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Track 404 errors if needed
  }, [location.pathname]);

  const handleGoHome = () => {
    navigate('/profile');
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="text-center max-w-md">
        <h1 className="mb-4 text-8xl font-bold text-primary text-[#119975]">
          404
        </h1>
        <h2 className="mb-6 text-3xl font-semibold text-foreground">
          Page Not Found
        </h2>
        <p className="mb-8 text-muted-foreground text-lg">
          Sorry, we couldn&apos;t find the page you&apos;re looking for.
        </p>

        <button
          onClick={handleGoHome}
          className="font-libreBaskerville  bg-[#119975] text-[#FFEBDB] font-poppins text-lg leading-[1em] px-6 py-4 bg-biowell-green hover:bg-biowell-green-dark text-lg font-semibold rounded-full transition duration-300 ease-in-out transform hover:scale-105 text-[#2B3133]"
          style={{ backgroundColor: '#119975' }}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
